import { AffiliationEndReason } from "@api/shared-runtime/enums";

export const AFFILIATION_END_REASON_LABELS: Record<
  AffiliationEndReason,
  string
> = {
  [AffiliationEndReason.MarkedInError]: "Marked in error",
  [AffiliationEndReason.Terminated]: "Terminated",
  [AffiliationEndReason.Resigned]: "Resigned",
  [AffiliationEndReason.Rejected]: "Rejected",
  [AffiliationEndReason.Withdrawn]: "Withdrawn",
};
